import { DialogRef } from '@angular/cdk/dialog';
import { ChangeDetectionStrategy, Component, computed, inject, OnDestroy, signal, Signal } from '@angular/core';
import { CookieConsentStore } from '../../../core/store/cookie-consent/cookie-consent.store';
import { CheckboxComponent, CheckboxModel } from '../../building-blocks/checkbox/checkbox.component';
import { KoalButtonComponent } from '../../building-blocks/koal-button/koal-button.component';
import { SnackbarService } from '../../building-blocks/snackbar/snackbar.service';

@Component({
  selector:        'app-cookie-consent-dialog',
  imports:         [
    KoalButtonComponent,
    CheckboxComponent
  ],
  templateUrl:     './cookie-consent-dialog.component.html',
  styleUrl:        './cookie-consent-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CookieConsentDialogComponent implements OnDestroy {

  dialogRef = inject(DialogRef);
  cookieStore = inject(CookieConsentStore);
  snackBar = inject(SnackbarService);

  public notwendigModel: CheckboxModel[] = [
    {
      key:     'notwendig',
      checked: true,
      label:   'Notwendig'
    }
  ];

  showNotwendingText = signal<boolean>(false);

  ngOnDestroy() {
    this.snackBar.showSnackBar('Einstellungen gespeichert!');
    this.cookieStore.setCookieDialogShown();
  }
}
